import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Button from '@atlaskit/button/loading-button';
import { Checkbox } from '@atlaskit/checkbox';
import Form, { CheckboxField, FormFooter, FormSection } from '@atlaskit/form';
import { ButtonClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { PartnerTierTypes } from '@atlassian/mpac-types';
import { SelectInput } from '@atlassian/mpac-ui';
import React from 'react';
import { MANAGE_PARTNER_ADMIN_VIEW, SUBMIT_PARTNER_ADMIN_FORM } from '../../analytics/Events';
import TEST_ID from '../../constants/TestIds';
import SupportBaseUrlInput from './SupportBaseUrlInput';
export const partnerTierOptions = [{
  label: 'Silver',
  value: PartnerTierTypes.SILVER
}, {
  label: 'Gold',
  value: PartnerTierTypes.GOLD
}, {
  label: 'Platinum',
  value: PartnerTierTypes.PLATINUM
}];
const PartnerAdminForm = _ref => {
  let {
    supportBaseUrl,
    hasSolutionPartnerBenefit,
    marketplacePartnerTier,
    canImportLicenses,
    onSubmit: _onSubmit
  } = _ref;
  const initialMarketplacePartnerTier = marketplacePartnerTier;
  const fireAnalyticsEvent = useAnalyticsEvents();
  const trackFormSubmission = () => fireAnalyticsEvent({
    eventType: ButtonClickedEvent,
    eventContainer: MANAGE_PARTNER_ADMIN_VIEW,
    actionSubjectId: SUBMIT_PARTNER_ADMIN_FORM
  });
  return /*#__PURE__*/React.createElement(Form, {
    onSubmit: data => _onSubmit(_objectSpread(_objectSpread({}, data), {}, {
      initialSupportBaseUrl: supportBaseUrl,
      initialMarketplacePartnerTier
    }))
  }, _ref2 => {
    let {
      formProps,
      submitting,
      dirty
    } = _ref2;
    return /*#__PURE__*/React.createElement("form", _extends({}, formProps, {
      name: "partner-admin-form"
    }), /*#__PURE__*/React.createElement(SupportBaseUrlInput, {
      baseUrl: supportBaseUrl
    }), /*#__PURE__*/React.createElement(CheckboxField, {
      name: "hasSolutionPartnerBenefit",
      defaultIsChecked: hasSolutionPartnerBenefit
    }, _ref3 => {
      let {
        fieldProps
      } = _ref3;
      return /*#__PURE__*/React.createElement(Checkbox, _extends({}, fieldProps, {
        label: "The partner received the free licensing benefit from the Solution Partner program"
      }));
    }), /*#__PURE__*/React.createElement(SelectInput, {
      options: partnerTierOptions,
      name: "marketplacePartnerTier",
      label: "Marketplace Partner Tier",
      placeholder: "Select partner tier",
      defaultValue: partnerTierOptions.find(opt => opt.value === marketplacePartnerTier)
    }), /*#__PURE__*/React.createElement(FormSection, {
      title: "Grant access"
    }, /*#__PURE__*/React.createElement(CheckboxField, {
      name: "canImportLicenses",
      defaultIsChecked: canImportLicenses
    }, _ref4 => {
      let {
        fieldProps
      } = _ref4;
      return /*#__PURE__*/React.createElement(Checkbox, _extends({}, fieldProps, {
        label: "The partner may use the license import API"
      }));
    })), /*#__PURE__*/React.createElement(FormFooter, null, /*#__PURE__*/React.createElement(Button, {
      testId: TEST_ID.ADMIN_TAB_SAVE_FORM_BUTTON,
      type: "submit",
      appearance: "primary",
      isLoading: submitting,
      isDisabled: !dirty,
      onClick: trackFormSubmission
    }, "Save")));
  });
};
export default PartnerAdminForm;